import React, { createContext, useState, useContext } from 'react';

// Create the context
const ApiContext = createContext();

// Create a provider component
export const ApiProvider = ({ children }) => {
  const [offerList, setOfferList] = useState([]);
  const [poolBalance, setPoolBalance] = useState("");
  const [allVehiclesBalance, setAllVehiclesBalance] = useState(0);
  const [vehicleDetails, setVehicleDetails] = useState("");
  const [vehicleList, setVehicleList] = useState([]);
 
  const contextValue = {
    offerList,
    setOfferList,
    poolBalance,
    setPoolBalance,
    allVehiclesBalance,
    setAllVehiclesBalance,
    vehicleDetails,
    setVehicleDetails,
    vehicleList,
    setVehicleList
   
  };

  return (
    <ApiContext.Provider value={contextValue}>
      {children}
    </ApiContext.Provider>
  );
};

// Create a custom hook to use the context
export const useApiContext = () => {
  return useContext(ApiContext);
};
